import instance, { customConfig } from "../Utils/Interceptors/Interceptor";

const RegistraBitacoraMovimientoUsuario = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Bitacora/RegistraBitacoraMovimientoUsuario",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { RegistraBitacoraMovimientoUsuario };